import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { confirm } from "lib/@dialogs/confirm"
import { storeGroupData } from "routes/schedule/controller/store-group-data"
import { FolderContextMenu } from "routes/schedule/folder-manager/lib/folder-context-menu"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { PlanRoot } from "library/tree/constants.mjs"
import { isInPublishedRegime } from "routes/facilities/lib/when-parent-item"
import { cloneElement } from "react"
import { RefreshScheduleItem, RefreshTreeRoots, ScheduleFolderIcon } from "event-definitions"
import { parentTreeItem } from "library/tree/index.mjs"

FolderContextMenu.plug(removeType)

function removeType({ context }) {
    return (
        context.parentItem &&
        !context.parentItem[PlanRoot] &&
        !!context.parentItem.data?.type &&
        context.parentItem.data?.type !== "simple" &&
        context.parentItem.data?.type !== "group" &&
        !isInPublishedRegime(context) &&
        !context.isRegimeDraftLocked && <RemoveType priority={1000} />
    )
}

function RemoveType() {
    const { parentItem, refresh, parentRefresh } = useBoundContext()
    return <ContextMenuItem divider={true} icon="ic:sharp-clear" label="Convert to folder" onClick={convertBack} />

    async function convertBack() {
        if (
            await confirm(
                "Are you sure you want to convert this group back to a simple folder?  You will lose all of the additional configuration applied to it permanently.",
                "Convert to folder"
            )
        ) {
            const newData = buildSimpleFolderData(parentItem)
            await storeGroupData(parentItem.id, newData)
            syncNode(parentItem, newData)
            notifyScheduleTree(parentItem)
            RefreshTreeRoots.raiseOnceDelay(200)
            refresh?.()
            parentRefresh?.()
        }
    }

    function buildSimpleFolderData(item) {
        return {
            image: item.data?.image,
            name: item.label,
            type: "simple",
        }
    }

    function syncNode(item, data) {
        item.data = { ...data }
        if (item.$?.data) {
            item.$.data = { ...data }
        }
        const { icon } = ScheduleFolderIcon.call({ icon: undefined, data: item })
        if (item.content) {
            item.content = cloneElement(item.content, {
                icon,
                caption: data.name ?? item.label,
                entry: item,
            })
        }
    }

    function notifyScheduleTree(item) {
        let current = item
        while (current) {
            if (current.id) {
                RefreshScheduleItem(current.id).raiseOnce()
            }
            current = current[parentTreeItem]
        }
    }
}
